import * as React from 'react';
import { SurfaceContext } from '../../types/contexts';
import { createSurfaceContextProvider } from '../common/surface-context-provider';

export const AddDevBoxPanelContext = React.createContext<SurfaceContext>({ isOpen: false });
export const AddDevBoxPanelContextProvider = createSurfaceContextProvider(AddDevBoxPanelContext);
